NtechApp.JobForm = function($view) {
    var me = this;

    this._$view = null;
    this._contactField = null;

    this._construct = function() {
        me._$view = $view;
        me._contactField = new NtechApp.JobFormContactField($view, "#job_contactText");

        me._bindEvents();
    }

    this._bindEvents = function() {
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.JobForm, {

});